import { createFileRoute, Outlet } from "@tanstack/react-router";

import { SettingsLayout } from "@/features/my/settings";

export const Route = createFileRoute("/(member)/(protected)/my/settings")({
  component: SettingsRoute,
});

function SettingsRoute() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
